module.exports = __webpack_public_path__ + "img/orange-question-mark.d1190e3a.svg";